$(document).ready(function() {
    var getVal = $("product-form.product-form form input.product-variant-id").val();
        console.log(getVal)
        var getdiscounted = $("select.dynamic-variants option[value='"+getVal+"']").attr("discounted-price");
        console.log(getdiscounted)
        $("span.custom-sale-badge").text(getdiscounted)
    $(document).on("change", "variant-selects input", function(){
         setTimeout(function(){
        var getVal = $("product-form.product-form form input.product-variant-id").val();
        console.log(getVal)
        var getdiscounted = $("select.dynamic-variants option[value='"+getVal+"']").attr("discounted-price");
        console.log(getdiscounted)
        $("span.custom-sale-badge").text(getdiscounted)
        }, 2000);
    })
    $(".sticky-atc__btnn").on("click", function (){
        $(".product-form__submit").trigger("click");
    })
    
})